import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
var Footer = function () {
    var style1 = {
        backgroundColor: '#c20'
    };
    var style2 = {
        color: '#fff'
    };
    return (_jsx("div", { className: "temp-footer", children: _jsxs("div", { className: "g", children: [_jsx("div", { className: "u-sm-4 text-center", children: _jsx(NavLink, { to: "/mobile/authorized/games", className: function (_a) {
                            var isActive = _a.isActive;
                            return classNames('button--link', { current: isActive });
                        }, children: _jsx("i", { className: "icon--md ion-trophy" }) }) }), _jsx("div", { className: "u-sm-4 text-center", style: style1, children: _jsx(NavLink, { to: "/mobile/authorized/score", className: function (_a) {
                            var isActive = _a.isActive;
                            return classNames('button--link', { current: isActive });
                        }, style: style2, children: _jsx("i", { className: "icon--md ion-plus" }) }) }), _jsx("div", { className: "u-sm-4 text-center", children: _jsx(NavLink, { to: "/mobile/authorized/expectations", className: function (_a) {
                            var isActive = _a.isActive;
                            return classNames('button--link', { current: isActive });
                        }, children: _jsx("i", { className: "icon--md ion-flag" }) }) })] }) }));
};
export default Footer;
